import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { SharedService } from './../../shared/shared.service';
import { AgentList } from '../../shared/agent.model';
import { AgencyInfo } from '../../shared/agency.model';
/*import { SearchFilterPipe } from '../../shared/search-filter.pipe';*/

@Component({
  selector: 'app-agent-grid',
  templateUrl: './agent-grid.component.html',
  styleUrls: ['./agent-grid.component.css']
})
export class AgentGridComponent implements OnInit {
  isDesktopView : boolean;
  showCard : object = { };
  public agentList : Array <AgentList>;
  private agentListSubscription : Subscription;
  iataNumber : String;
  public totalItems: number;
  public currentPage: number = 1;
  public itemsPerPage: number = 5;
  public maxSize: number = 3;
  public listedItems: Array <AgentList>;
  public filteredItems: Array <AgentList>;
  public finalItems: Array <AgentList>;
  public selItemsPerpage: number = 5;
  public travelAgencyStatus:String="0";

  public activityStatusFlag: string="All";

  agency = [];  
  constructor(private router: Router, private sharedService : SharedService) {
  	this.isDesktopView = this.sharedService.getDeviceType();
  }

  ngOnInit() {
    if(this.sharedService.getAgencyInfoDetails()) {
      this.travelAgencyStatus=this.sharedService.getAgencyInfoDetails().travelAgentStatus;
      this.sharedService.getAgentList(this.sharedService.getAgencyInfoDetails().iatacode)
      .subscribe((response) => {
        this.agentList = response;
        this.totalItems = this.agentList.length;
        this.buildPageContents(this.currentPage);
      });
    }
    this.agentListSubscription = this.sharedService.agentList$.subscribe((data : AgencyInfo) => {
        this.iataNumber = data.iatacode;
        this.sharedService.getAgentList(this.iataNumber)
        .subscribe((response) => {
          this.agentList = response;
          this.totalItems = this.agentList.length;
          this.buildPageContents(this.currentPage);
        });
    });
  }

  openCard(agent) {
  	//this.showCard = !this.showCard;
    Object.keys(this.showCard).forEach(h => {
      this.showCard[h] = false;
    });
    this.showCard[agent.userId] = true;
  }
  
  createAgent() {
    this.router.navigate(['/create', 'createAgent']);
  }

  searchFilter(value: string, event) {
    if (!value) {
      this.filteredItems = [];
      this.totalItems = this.agentList.length;
      this.currentPage = 1;
      this.buildPageContents(this.currentPage);
    }
    else {
      if(this.agentList.filter(item => 
        (item['firstName'].toUpperCase().indexOf(value.toUpperCase()) !== -1) ||
        (item['userId'].toUpperCase().indexOf(value.toUpperCase()) !== -1)
        )
      ) {
        this.filteredItems = this.agentList.filter(item => 
          (item['firstName'].toUpperCase().indexOf(value.toUpperCase()) !== -1) ||
          (item['userId'].toUpperCase().indexOf(value.toUpperCase()) !== -1) 
        );
        if(this.filteredItems.length==0){
          this.listedItems.length=0;
          this.totalItems = this.filteredItems.length;
        }
        else{
          this.totalItems = this.filteredItems.length;
          this.currentPage = 1;
          this.buildPageContents(this.currentPage);
          return this.agentList.filter(item => 
            (item['firstName'].toUpperCase().indexOf(value.toUpperCase()) !== -1) ||
            (item['userId'].toUpperCase().indexOf(value.toUpperCase()) !== -1)
          );
        }
        
      }
    }
  }


  public activityFlagChanged(flag,itemList){
    
    if(flag == "Active")
    {
      return itemList.filter(item => 
        (
          (item['isUserActive'] == true) 
        )
      );
    }
    else if(flag == "Inactive")
    {
      return itemList.filter(item => 
        (
          (item['isUserActive'] != true) 
        )
      );
    }
    else
    {
      return itemList;
    }
  }

  public pageChanged(event: any): void {
    this.buildPageContents(event.page);
  }

  public activityClick() {
    this.buildPageContents(this.currentPage);
  }

  public buildPageContents(currentPage) {
    let newArray = [];
    let startItem = (currentPage-1) * this.itemsPerPage;
    if(startItem < 1) startItem = 0;
    let endItem = this.itemsPerPage;
    if(endItem < 1) endItem = this.totalItems;

    for(let i=0; i < endItem; i++ ) {
      if(this.filteredItems && this.filteredItems.length > 0) {
        this.finalItems = this.activityFlagChanged(this.activityStatusFlag,this.filteredItems);
      }
      else {
        this.finalItems = this.activityFlagChanged(this.activityStatusFlag,this.agentList);
      }
    }
    this.totalItems = this.finalItems.length;
    for(let i=0; i < endItem; i++ ) {
      if(this.filteredItems && this.filteredItems.length > 0) {
        if(this.totalItems > 0 && this.finalItems[startItem+i]) {          
          newArray.push(this.finalItems[startItem+i])
        }
      } else if(this.filteredItems && this.totalItems === 0) {
        newArray = [];
      }
      else {
        if(this.finalItems[startItem+i])
          newArray.push(this.finalItems[startItem+i])
      }
    }

    this.listedItems = newArray; 
      
  }

  ngOnDestroy(){
    this.agentListSubscription.unsubscribe();
  }
  public onChangeEvent(evnet: any): void{
    this.itemsPerPage=this.selItemsPerpage;
    this.buildPageContents(this.currentPage);
  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/create-agency/agent-grid/agent-grid.component.ts